module.exports = "https://cdn.schoolblocks.com/assets/_next/static/media/icon_1_drawing_x32-4f3c6.png";